export class ZefStateSwitcherState {
  states: Record<string, string>;

  constructor() {
    this.states = {};
  }
}
